// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".addDirection[data-v-457fdfea] {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n}\n.close-icon[data-v-457fdfea] {\n  height: 16px;\n  width: 17px;\n}\n.customSizeSuggestedModal[data-v-457fdfea] {\n  width: 800px;\n}", ""]);
// Exports
module.exports = exports;
